import { useEffect, useState } from 'react';

/**
 * PWA detection utilities for ensuring persistent storage
 */

export interface PWADetectionResult {
  isPWA: boolean;
  isStandalone: boolean;
  platform: 'ios' | 'android' | 'windows' | 'macos' | 'other';
}

/**
 * Detects if the app is running as a PWA
 */
export const detectPWA = (): PWADetectionResult => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                      (window.navigator as any).standalone === true;

  const platform = detectPlatform();

  return {
    isPWA: isStandalone,
    isStandalone,
    platform
  };
};

/**
 * Detects the current platform
 */
const detectPlatform = (): PWADetectionResult['platform'] => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  } else if (/android/.test(userAgent)) {
    return 'android';
  } else if (/windows/.test(userAgent)) {
    return 'windows';
  } else if (/mac/.test(userAgent)) {
    return 'macos';
  }
  
  return 'other';
};

/**
 * Hook to check PWA status on mount
 */
export const usePWADetection = () => {
  const [pwaStatus, setPwaStatus] = useState<PWADetectionResult | null>(null);

  useEffect(() => {
    setPwaStatus(detectPWA());
  }, []);

  return pwaStatus;
};
